module.exports = __webpack_public_path__ + "img/damage.2739d0fd.svg";